export default {
    ADD_TAB(state, tab) {
        const exists = state.tabs.find(
            item => item.fullPath === tab.fullPath
        )

        if (!exists) {
            state.tabs.push(tab)

            const MAX_TABS = 20

            if (state.tabs.length > MAX_TABS) {
                state.tabs.shift()
            }
        }

        state.activeTab = tab.fullPath
    },

    REMOVE_TAB(state, fullPath) {
        state.tabs = state.tabs.filter(
            item => item.fullPath !== fullPath
        )

        if (state.activeTab === fullPath) {
            state.activeTab =
                state.tabs[state.tabs.length - 1]?.fullPath || null
        }
    },

    SET_ACTIVE_TAB(state, fullPath) {
        state.activeTab = fullPath
    },
    SET_USE_TABS_NAVIGATION(state, value) {
        state.useTabsNavigation = value

        localStorage.setItem(
            'useTabsNavigation',
            value
        )
    }
}